import { Routes } from '@angular/router';
import { PanelComponent } from './modules/panel/components/panel/panel.component';
import { VideoComponent } from './modules/panel/components/video/video.component';
import { SaveScreenComponent } from './modules/panel/components/save-screen/save-screen.component';
import { PluviometerComponent } from './modules/sensors/pluviometer/pluviometer.component';
import { HomePageComponent } from './modules/home/pages/home-page/home-page.component';
import { EM310Component } from './modules/sensors/EM310-UDL-915M/EM310.component';
import { ProjectPageComponent } from './modules/home/pages/project/project.component';
import { MapPageComponent } from './modules/map/pages/map-page/map-page.component';
import { ResumePanelComponent } from './modules/panel/components/resume-panel/resume-panel.component';
import { SensorEnvironmentComponent } from './modules/sensors/enviroment/enviroment.component';
import { ProjectListPageComponent } from './modules/home/pages/project-list/project-list-page.component';
import { MapTransportPageComponent } from './modules/map/pages/map-transport-page/map-transport-page.component';

export const routes: Routes = [
  {
    path: 'panel/:id',
    component: PanelComponent,
  },
  {
    path: 'resume-panel/:id',
    component: ResumePanelComponent,
  },
  {
    path: 'panel/save-screen',
    component: SaveScreenComponent
  },
  {
    path: 'video/:id',
    component: VideoComponent,
  },
  {
    path: 'pluviometer/:id',
    component: PluviometerComponent,
  },
  {
    path: 'pluviometers',
    component: PluviometerComponent,
  },
  {
    path: 'EM310/:id',
    component: EM310Component,
  },
  {
    path: 'enviroment-sensor',
    component: SensorEnvironmentComponent,
  },
  {
    path: 'map',
    component: MapPageComponent,
  },
  {
    path: 'trasnport-map',
    component: MapTransportPageComponent,
  },
  {
    path: 'project/:id',
    component: ProjectPageComponent
  },
  {
    path: 'projects',
    component: ProjectListPageComponent
  },
  {
    path: '',
    component: HomePageComponent,
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];
